function mountGTMContainer(gtmId) {
  const containerId = `amg_${gtmId}`;
  const container = this.doc.getElementById(containerId);
  if (!container) {
    const gtmScript = this.doc.createElement('script');
    gtmScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
    gtmScript.async = 'async';
    gtmScript.id = containerId;
    this.doc.head.appendChild(gtmScript);
    this.win.dataLayer = this.win.dataLayer || [];
    function gtag() {
      // you _have_ to use arguments here. DO NOT use the rest operator
      /* eslint-disable-next-line */
      this.win.dataLayer.push(arguments);
    }
    this.win.gtag = gtag.bind(this);
  }
}

function fireGDNPageView() {
  const gtmId = this.getOcodeValue('component.PartialPageViewPixel.gdnRemarketingTrackingId');
  this.mountGTMContainer(gtmId)
  this.win.gtag('js', new Date());
  this.win.gtag('config', gtmId);
  return null;
}

function fireGDNConversion() {
  const overridePrefix = this.getOverridePrefix();
  const id = this.getOcodeValue(`${overridePrefix}.gdnConversionGtagId`);
  const eventId = this.getOcodeValue(`${overridePrefix}.gdnConversionId`);
  const value = this.getOcodeValue(`${overridePrefix}.gdnConversionValue`)
  function gtagReportConversion(url) {
    const callback = () => {
      if (typeof url !== 'undefined') {
        this.win.location = url;
      }
    };
    const opts = {
      send_to: `${id}/${eventId}`,
      event_callback: callback,
    };
    if (value) {
      opts.currency = 'USD';
      opts.value = value;
    }
    this.win.gtag('event', 'conversion', opts);
    return false;
  }
  this.win.gtag_report_conversion = gtagReportConversion.bind(this);
  this.win.gtag_report_conversion();
}

module.exports = {
  mountGTMContainer,
  fireGDNPageView,
  fireGDNConversion,
};
